import {Module} from 'vuex';
import {state} from './state';
//import {actions} from './actions'
import {mutations} from './mutations';
import {VerdeState} from './types';
import {RootState} from '@/store/types';
const namespaced: boolean=true;

export const verdeModule:Module<VerdeState,RootState>={
    namespaced,
    state,
    mutations
    
}